import { render, staticRenderFns } from "./Inicial.vue?vue&type=template&id=08b71504&"
import script from "./Inicial.vue?vue&type=script&lang=js&"
export * from "./Inicial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Inicial.vue"
export default component.exports